import dayjs from 'dayjs';
import type { CatalogoProdutoAdicionalItem } from '@/features/catalogo/types/CatalogoProduto';
import { DATE_TIME_FORMAT_API } from '@/std/const/date';
import { unreachable } from '@/std/util';
import type { ProdutoAdicionalItemBody } from '../types/ProdutoAdicionalItem';
import { ProdutoAdicionalOrdenacao } from '../types/enum';

export function orderAdicionaisItens<
    T extends ProdutoAdicionalItemBody | CatalogoProdutoAdicionalItem,
>(itens: T[], ordenacao: ProdutoAdicionalOrdenacao): T[] {
    switch (ordenacao) {
        case ProdutoAdicionalOrdenacao.OrdemInsercao: {
            return itens.toSorted((a, b) => {
                const dateA = dayjs(a.pai_data_insercao, DATE_TIME_FORMAT_API);
                const dateB = dayjs(b.pai_data_insercao, DATE_TIME_FORMAT_API);

                if (dateA.isBefore(dateB)) {
                    return -1;
                }

                if (dateA.isAfter(dateB)) {
                    return 1;
                }

                return 0;
            });
        }
        case ProdutoAdicionalOrdenacao.NomeItemAZ: {
            return itens.toSorted((a, b) => (a.pai_nome || '').localeCompare(b.pai_nome || ''));
        }
        case ProdutoAdicionalOrdenacao.PrecoUnitarioAZ: {
            return itens.toSorted(
                (a, b) => (a.pai_valor_unitario || 0) - (b.pai_valor_unitario || 0),
            );
        }
        case ProdutoAdicionalOrdenacao.PrecoUnitarioZA: {
            return itens.toSorted(
                (a, b) => (b.pai_valor_unitario || 0) - (a.pai_valor_unitario || 0),
            );
        }
        default: {
            unreachable(ordenacao);
        }
    }
}
